export default {
	basic (credentials) {
		return {
			headers: {
				'Authorization': 'Basic ' + window.btoa(credentials.email + ':' + credentials.password)
			}
		}
	},
	bearer () {
		return {
			headers: {
				'Authorization': 'Bearer ' + window.localStorage.getItem('token')
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/headers.js